export default {"src":"https://images-cdn-staging.curipod.com/d-a311fe5f/_next/static/media/common_sense_media.9c180185.svg","height":123,"width":300};